// extracted by mini-css-extract-plugin
export default {"root":"LoadingPlaceholder_root__IZVkh","content":"LoadingPlaceholder_content__p0M9C","title":"LoadingPlaceholder_title__8RUCX","reveal":"LoadingPlaceholder_reveal__bxgiA"};